import React from 'react';

export default class CustomInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    render() {
        return(
            <div style={mainStyle}>
                <img src={this.props.icona} alt="" style={{ width: 25, height: 25, marginLeft: 10, marginTop: 5 }} />
                <p style={{ ...child, marginTop: 10 }} >{this.props.testo}</p>
            </div>
        );
    }
}

const mainStyle = {
    display: 'flex', 
    flexDirection: 'row', 
    marginBottom: 10, 
    borderRadius: 5,
    border: '1px solid darkgrey',
    maxHeight: 60,
    paddingTop: 10, 
    paddingBottom: 10, 
    paddingLeft: 10, 
    paddingRight: 10,
};

const child = {
    marginLeft: 5,
    height: 40,
}
 